(function () {
  var MAX_PHOTOS = 6;
  var MIN_PHOTOS = 1;
  var MAX_BYTES = 5 * 1024 * 1024;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function initEstimateDrawer() {
    var drawer = document.getElementById('chakmar-estimate-drawer');
    if (!drawer || drawer.dataset.estimateInit === '1') return;
    drawer.dataset.estimateInit = '1';

    var form = drawer.querySelector('.chakmar-estimate-form');
    if (!form) return;

    var stepLabel = drawer.querySelector('[data-estimate-step-label]');
    var feedback = drawer.querySelector('[data-estimate-feedback]');
    var successPanel = drawer.querySelector('[data-estimate-success]');
    var successText = drawer.querySelector('[data-estimate-success-text]');
    var backBtn = drawer.querySelector('[data-estimate-back]');
    var nextBtn = drawer.querySelector('[data-estimate-next]');
    var submitBtn = drawer.querySelector('[data-estimate-submit]');
    var doneBtn = drawer.querySelector('[data-estimate-done]');
    var photosInput = drawer.querySelector('#estimate-photos');
    var photosBtn = drawer.querySelector('[data-estimate-photos-btn]');
    var photosList = drawer.querySelector('[data-estimate-photos-list]');
    var iframe = document.getElementById('chakmar-estimate-target');
    var currentStep = 1;
    var selectedFiles = [];
    var submitted = false;

    function setFeedback(message, type) {
      if (!feedback) return;
      feedback.textContent = message || '';
      feedback.classList.remove('is-error', 'is-success');
      if (type) feedback.classList.add(type);
    }

    function showSuccessState() {
      form.classList.add('is-success');
      if (successPanel) successPanel.hidden = false;
      if (successText) successText.textContent = form.dataset.msgSuccess || '';
      if (stepLabel) stepLabel.textContent = '3/3';
      if (backBtn) backBtn.hidden = true;
      if (nextBtn) nextBtn.hidden = true;
      if (submitBtn) {
        submitBtn.hidden = true;
        submitBtn.disabled = false;
      }
      if (doneBtn) doneBtn.hidden = false;
      setFeedback('');
      if (successPanel) {
        successPanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function clearSuccessState() {
      form.classList.remove('is-success');
      if (successPanel) successPanel.hidden = true;
      if (successText) successText.textContent = '';
      if (doneBtn) doneBtn.hidden = true;
    }

    function showStep(step) {
      clearSuccessState();
      currentStep = step;
      drawer.querySelectorAll('[data-estimate-step]').forEach(function (el) {
        var n = Number(el.getAttribute('data-estimate-step'));
        var active = n === step;
        el.hidden = !active;
        el.classList.toggle('is-active', active);
      });
      if (stepLabel) stepLabel.textContent = step + '/3';
      if (backBtn) backBtn.hidden = step === 1;
      if (nextBtn) nextBtn.hidden = step === 3;
      if (submitBtn) submitBtn.hidden = step !== 3;
      if (doneBtn) doneBtn.hidden = true;
      setFeedback('');
    }

    function closeSelects(except) {
      drawer.querySelectorAll('[data-estimate-select]').forEach(function (wrap) {
        if (except && wrap === except) return;
        wrap.classList.remove('is-open');
        var list = wrap.querySelector('.chakmar-estimate-select__list');
        var trigger = wrap.querySelector('.chakmar-estimate-select__trigger');
        if (list) list.hidden = true;
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }

    drawer.querySelectorAll('[data-estimate-select]').forEach(function (wrap) {
      var trigger = wrap.querySelector('.chakmar-estimate-select__trigger');
      var list = wrap.querySelector('.chakmar-estimate-select__list');
      var label = wrap.querySelector('[data-estimate-select-label]');
      var input = wrap.querySelector('input[type="hidden"]');
      if (!trigger || !list || !label || !input) return;

      trigger.addEventListener('click', function () {
        var open = wrap.classList.contains('is-open');
        closeSelects();
        if (!open) {
          wrap.classList.add('is-open');
          list.hidden = false;
          trigger.setAttribute('aria-expanded', 'true');
        }
      });

      list.querySelectorAll('[role="option"]').forEach(function (option) {
        option.addEventListener('click', function () {
          var value = option.getAttribute('data-value') || '';
          input.value = value;
          label.textContent = option.textContent.trim();
          list.querySelectorAll('[role="option"]').forEach(function (opt) {
            opt.setAttribute('aria-selected', opt === option ? 'true' : 'false');
          });
          closeSelects();
        });
      });
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-estimate-select]')) closeSelects();
    });

    function clearPhotoSlots() {
      form.querySelectorAll('.chakmar-estimate-photo-slot').forEach(function (slot) {
        var empty = new DataTransfer();
        slot.files = empty.files;
        slot.removeAttribute('required');
      });
    }

    function syncPhotoSlots() {
      clearPhotoSlots();
      selectedFiles.forEach(function (file, index) {
        var slot = form.querySelector('#estimate-photo-' + (index + 1));
        if (!slot) return;
        var dt = new DataTransfer();
        dt.items.add(file);
        slot.files = dt.files;
        if (index < MIN_PHOTOS) slot.setAttribute('required', 'required');
      });
      if (photosInput) {
        var picker = new DataTransfer();
        selectedFiles.forEach(function (file) {
          picker.items.add(file);
        });
        photosInput.files = picker.files;
      }
    }

    function renderPhotos() {
      if (!photosList) return;
      photosList.innerHTML = '';
      selectedFiles.forEach(function (file, index) {
        var li = document.createElement('li');
        var name = document.createElement('span');
        name.textContent = file.name;
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.setAttribute('aria-label', form.dataset.removePhoto || 'Remove');
        remove.textContent = '×';
        remove.addEventListener('click', function () {
          selectedFiles.splice(index, 1);
          syncPhotoSlots();
          renderPhotos();
        });
        li.appendChild(name);
        li.appendChild(remove);
        photosList.appendChild(li);
      });
    }

    if (photosBtn && photosInput) {
      photosBtn.addEventListener('click', function () {
        photosInput.click();
      });

      photosInput.addEventListener('change', function () {
        var incoming = Array.prototype.slice.call(photosInput.files || []);
        incoming.forEach(function (file) {
          if (selectedFiles.length >= MAX_PHOTOS) return;
          if (file.size > MAX_BYTES) return;
          selectedFiles.push(file);
        });
        syncPhotoSlots();
        renderPhotos();
      });
    }

    function fieldValue(selector) {
      var el = form.querySelector(selector);
      return el ? String(el.value || '').trim() : '';
    }

    function mapToExpertiseFields() {
      var first = fieldValue('#estimate-first-name');
      var last = fieldValue('#estimate-last-name');
      var category = form.querySelector('input[name="category"]:checked');
      var categoryLabel = category
        ? (category.closest('label') ? category.closest('label').textContent.trim() : category.value)
        : '';
      var condition = form.querySelector('#estimate-condition');
      var conditionLabel = '';
      if (condition && condition.value) {
        var conditionWrap = condition.closest('[data-estimate-select]');
        if (conditionWrap) {
          var opt = conditionWrap.querySelector('[role="option"][data-value="' + condition.value + '"]');
          conditionLabel = opt ? opt.textContent.trim() : condition.value;
        } else {
          conditionLabel = condition.value;
        }
      }

      var extras = [];
      if (form.querySelector('input[name="has_invoice"]:checked')) extras.push('invoice');
      if (form.querySelector('input[name="has_box"]:checked')) extras.push('original box');
      if (form.querySelector('input[name="has_dustbag"]:checked')) extras.push('dustbag');

      var comments = [
        '[Deposit / Estimate form]',
        'Condition: ' + conditionLabel,
        'Desired price (€): ' + fieldValue('#estimate-price'),
        'Accessories: ' + (extras.length ? extras.join(', ') : 'none'),
        'Address: ' +
          [fieldValue('#estimate-address'), fieldValue('#estimate-postal'), fieldValue('#estimate-city')]
            .filter(Boolean)
            .join(', '),
        '',
        fieldValue('#estimate-description')
      ].join('\n');

      var customerName = form.querySelector('[data-estimate-map="customer_name"]');
      var bagModel = form.querySelector('[data-estimate-map="bag_model"]');
      var bagComments = form.querySelector('[data-estimate-map="bag_comments"]');
      if (customerName) customerName.value = [first, last].filter(Boolean).join(' ');
      if (bagModel) bagModel.value = categoryLabel || (category ? category.value : 'Deposit item');
      if (bagComments) bagComments.value = comments;

      var phone = form.querySelector('#estimate-phone');
      if (phone && !phone.value.trim()) {
        phone.value = '-';
      }

      syncPhotoSlots();
    }

    function validateStep(step) {
      if (step === 1) {
        var category = form.querySelector('input[name="category"]:checked');
        var brand = form.querySelector('#estimate-brand');
        var condition = form.querySelector('#estimate-condition');
        if (!category || !brand || !brand.value || !condition || !condition.value) {
          setFeedback(form.dataset.errStep1, 'is-error');
          return false;
        }
        return true;
      }

      if (step === 2) {
        if (selectedFiles.length < MIN_PHOTOS || selectedFiles.length > MAX_PHOTOS) {
          setFeedback(form.dataset.errPhotos, 'is-error');
          return false;
        }
        var oversized = selectedFiles.some(function (file) {
          return file.size > MAX_BYTES;
        });
        if (oversized) {
          setFeedback(form.dataset.errPhotos, 'is-error');
          return false;
        }
        var description = form.querySelector('#estimate-description');
        var price = form.querySelector('#estimate-price');
        if (!description || !description.value.trim() || !price || !price.value) {
          setFeedback(form.dataset.errStep2, 'is-error');
          return false;
        }
        return true;
      }

      if (step === 3) {
        var requiredIds = [
          'estimate-first-name',
          'estimate-last-name',
          'estimate-address',
          'estimate-postal',
          'estimate-city',
          'estimate-email'
        ];
        var valid = requiredIds.every(function (id) {
          var el = form.querySelector('#' + id);
          return el && el.value.trim();
        });
        var email = form.querySelector('#estimate-email');
        if (!valid || (email && email.validity && !email.validity.valid)) {
          setFeedback(form.dataset.errStep3, 'is-error');
          return false;
        }
        return true;
      }

      return true;
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (!validateStep(currentStep)) return;
        showStep(Math.min(3, currentStep + 1));
      });
    }

    if (backBtn) {
      backBtn.addEventListener('click', function () {
        showStep(Math.max(1, currentStep - 1));
      });
    }

    form.addEventListener('submit', function (event) {
      if (!validateStep(3)) {
        event.preventDefault();
        return;
      }
      mapToExpertiseFields();
      if (selectedFiles.length < MIN_PHOTOS) {
        event.preventDefault();
        setFeedback(form.dataset.errPhotos, 'is-error');
        return;
      }
      submitted = true;
      setFeedback('');
      if (submitBtn) submitBtn.disabled = true;
    });

    if (iframe) {
      iframe.addEventListener('load', function () {
        if (!submitted) return;
        submitted = false;

        form.reset();
        selectedFiles = [];
        clearPhotoSlots();
        renderPhotos();
        drawer.querySelectorAll('[data-estimate-select]').forEach(function (wrap) {
          var label = wrap.querySelector('[data-estimate-select-label]');
          var input = wrap.querySelector('input[type="hidden"]');
          var options = wrap.querySelectorAll('[role="option"]');
          if (input) input.value = '';
          if (label && options.length) label.textContent = options[0].textContent.trim();
          options.forEach(function (opt, idx) {
            opt.setAttribute('aria-selected', idx === 0 ? 'true' : 'false');
          });
        });

        showSuccessState();
      });
    }

    if (doneBtn) {
      doneBtn.addEventListener('click', function () {
        var closeBtn = drawer.querySelector('.chakmar-estimate-drawer__close');
        if (closeBtn) {
          closeBtn.click();
        } else if (typeof closeDrawer === 'function') {
          closeDrawer(drawer);
        } else {
          drawer.classList.remove('active', 'drawer-pannel');
          drawer.setAttribute('aria-hidden', 'true');
          drawer.setAttribute('inert', '');
          document.body.classList.remove('overflow-hidden');
        }
        showStep(1);
      });
    }

    showStep(1);
  }

  ready(initEstimateDrawer);
  document.addEventListener('shopify:section:load', initEstimateDrawer);
})();
